function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.75c-1.659 0-3.125 1.506-3.125 3.521 0 2.015 1.466 3.521 3.125 3.521s3.125-1.506 3.125-3.52c0-2.016-1.466-3.522-3.125-3.522zM7.375 7.271C7.375 4.568 9.379 2.25 12 2.25s4.625 2.318 4.625 5.021-2.004 5.021-4.625 5.021-4.625-2.318-4.625-5.02zm-.3 9.2C5.7 17.272 5 18.249 5 19.146c0 .42.138.604.337.735.264.173.716.296 1.414.345.68.047 1.49.02 2.398-.022l.422-.02A50.013 50.013 0 0112 20.103c.823 0 1.653.04 2.43.078l.421.02c.909.043 1.717.07 2.398.023.698-.05 1.15-.172 1.414-.345.2-.13.337-.316.337-.735 0-.897-.7-1.874-2.075-2.673-1.342-.78-3.148-1.275-4.925-1.275-1.777 0-3.583.494-4.925 1.275zm-.754-1.296c1.582-.92 3.651-1.478 5.679-1.478 2.028 0 4.097.558 5.679 1.478 1.548.9 2.821 2.273 2.821 3.97 0 .879-.355 1.557-1.014 1.99-.595.39-1.367.532-2.132.586-.78.055-1.672.023-2.573-.02l-.433-.02A48.34 48.34 0 0012 21.603c-.783 0-1.57.038-2.348.076l-.433.021c-.901.043-1.792.075-2.573.02-.765-.054-1.537-.196-2.132-.587-.659-.432-1.014-1.11-1.014-1.989 0-1.697 1.273-3.07 2.821-3.97z",
  fill: "#1A1C21"
});

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgUser;